import type {RemoteClientV2} from '@deezer/logcenter';
import {RECLog, RECLogContext} from '@deezer/logcenter';
import type {Metric, WebVitalsMetricsParams, WebVitalsPayload} from './types';

// Constants
const TYPE = 'vitals.web_vitals';
const VERSION = '1.0.0';

const recLogContext = new RECLogContext({
	name: 'standalone-shaker',
	version: '1.0.0',
});

class WebVitalsMetrics extends RECLog<RemoteClientV2 & WebVitalsPayload> {
	#name: Metric;
	#value: number;
	#userId?: string;
	#page_category?: string;
	#url?: string;
	#navigationType?: string;
	#rating?: string;

	constructor(params: WebVitalsMetricsParams) {
		super({
			type: TYPE,
			version: VERSION,
			...recLogContext,
		});

		this.#name = params.name;
		this.#value = params.value;

		if ('userId' in params) {
			this.#userId = params.userId;
		}

		if ('url' in params) {
			this.#url = params.url;
		}

		if ('pageCategory' in params) {
			this.#page_category = params.pageCategory;
		}

		if ('navigationType' in params) {
			this.#navigationType = params.navigationType;
		}

		if ('rating' in params) {
			this.#rating = params.rating;
		}
	}

	serialize() {
		return {
			...super.serialize(),
			name: this.#name,
			value: this.#value,
			user_id: this.#userId,
			page_category: this.#page_category,
			url: this.#url,
			navigation_type: this.#navigationType,
			rating: this.#rating,
		};
	}
}

export default WebVitalsMetrics;
